import CashBankService from '@/services/cashbank.service.js'

const state = {
  accounts: [],
  stats: {
    totalBalance: 0,
    cashBalance: 0,
    bankBalance: 0,
    totalAccounts: 0
  },
  loading: false,
  currentAccount: null
}

const getters = {
  accounts: state => state.accounts,
  stats: state => state.stats,
  loading: state => state.loading,
  currentAccount: state => state.currentAccount
}

const actions = {
  async fetchAccounts({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await CashBankService.getAccounts(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_ACCOUNTS', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load accounts',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchAccountById({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await CashBankService.getAccountById(id)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CURRENT_ACCOUNT', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createAccount({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await CashBankService.createAccount(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account created successfully',
        { root: true }
      )
      // Refresh accounts list
      await dispatch('fetchAccounts')
      await dispatch('fetchStats')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to create account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateAccount({ commit, dispatch }, { id, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await CashBankService.updateAccount(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account updated successfully',
        { root: true }
      )
      // Refresh accounts list
      await dispatch('fetchAccounts')
      await dispatch('fetchStats')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteAccount({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await CashBankService.deleteAccount(id)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account deleted successfully',
        { root: true }
      )
      // Refresh accounts list
      await dispatch('fetchAccounts')
      await dispatch('fetchStats')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchStats({ commit, dispatch }) {
    try {
      const response = await CashBankService.getStats()
      const data = response.payload?.responseData || response.payload || response
      commit('SET_STATS', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load stats',
        { root: true }
      )
      throw error
    }
  },

  clearCurrentAccount({ commit }) {
    commit('SET_CURRENT_ACCOUNT', null)
  }
}

const mutations = {
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts
  },
  SET_STATS(state, stats) {
    state.stats = {
      totalBalance: stats.totalBalance || 0,
      cashBalance: stats.cashBalance || 0,
      bankBalance: stats.bankBalance || 0,
      totalAccounts: stats.totalAccounts || 0
    }
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_CURRENT_ACCOUNT(state, account) {
    state.currentAccount = account
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
